// "use strict";

import Constants from '../utils/Constants';
import {getStorageData,removeStorageData} from '../utils/Helper';
const _ = require("lodash");

class HttpRequest
{
    static setHeaders()
    {
        //set header
        // var language = Helper.getStorageData("accept_lang");
        // language = _.isEmpty(language) ? Constants.default_language : language;
        var header   = {};
        header.token = Constants.api_token;
        // header["Accept-Language"] = language;
        if (!_.isEmpty(localStorage.getItem(Constants.session_key))) {
            const api_token = getStorageData(Constants.session_key);
            header["Authorization"] = api_token;
        }
        // if (!_.isEmpty(localStorage.getItem(Constants.session_object))) {
        //     const user = Helper.getStorageData(Constants.session_object);
        //     header["user-token"] = user.api_token;
        // }
        // console.log(header)
        return header;
    }


    static makeRequest(method,url,params)
    {
        
        return new Promise((resolve, reject) => {
            fetch(url, {
                method: method,
                headers: new Headers(this.setHeaders()),
                body: params,
                mode:'cors'
            })
                .then((response) => response.json())
                .then((res) => {
                    if(res.resCode === 401){
                        removeStorageData();
                        return false;
                    }
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    static makeQueryStringUrl(url, form_data)
    {
        const data = [...form_data.entries()];
        const queryStringParam = data
            .map((x) => `${encodeURIComponent(x[0])}=${encodeURIComponent(x[1])}`)
            .join("&");
        return url + queryStringParam;
    }
}
export default HttpRequest;
